import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Gift from '../icons/Gift';

export default function ItemConvertLink() {
  const { t } = useTranslation(null, { useSuspense: false });

  return (
    <Link to="/item-convert" className="diamonds-conversion-to-item-convert">
      <Gift />
      <span>{t('index_item_convert')}</span>
      <span className="diamonds-conversion-caret">
        <svg>
          <use
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xlinkHref="img/icons/economy.svg?1510677573844#ic_caret_right"
          />
        </svg>
      </span>
    </Link>
  );
}
